<!--
 * @Description:评论列表
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-11-18 10:55:16
 * @LastEditors: mdb
-->
<template>
    <div class="commit-list" v-for="item in pageData" :key="item.id">
      <div class="flex">
        <p>{{ item.createByName }}</p>
        <p>{{ item.createTime }}</p>
      </div>
      <div v-html="xss(item.content)"></div>
      <template v-if="item.fileId && item.fileId.length">
        <p style="margin-bottom: -6px">附件：</p>
        <UploadFile v-model:value="item.fileId" view valueType="array" />
      </template>
      <div class="button">
        <a-button type="text" v-permission="permissionPage.delCommit" @click="handleDelCol(item)" danger>删除</a-button>
      </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import UploadFile from '@/components/UploadFile'
import Modal from '@/hooks/modalType'
import type { commentItem } from '@/typings/api/followUpManage'
import { followRecordsDetail, followRecordsDelComment } from '@/api/gucangSales/followUpManage'
import xss from 'xss'
const props = defineProps({
  data: {
    type: Array,
    default: () => {
      return []
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  id: String
})
const hasfetch = ref(false)
const commentList = ref([])
const pageData = computed(() => {
  if (hasfetch.value) {
    return commentList.value
  }
  return props.data || []
})
const refresh = () => {
  followRecordsDetail(props.id).then((res) => {
    hasfetch.value = true
    commentList.value = res.data.commentList
  })
}
const handleDelCol = (row: commentItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelComment(row.id).then((res) => {
        DcMessage.success('删除成功')
        refresh()
      })
    }
  })
}
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'ExportBtn'
}
</script>
<style scoped lang="scss">
.commit-list {
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9ff;
  width: 100%;
  position: relative;
  p {
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .button {
    position: absolute;
    right: 20px;
    top: 10px;
  }
}
.paddingLine {
  height: 12px;
  margin-left: -20px;
  margin-right: -20px;
  bottom: 0;
  background: #f9f9ff;
  margin-bottom: 16px;
}
</style>
